/**
 * Which of an issuer's ranges a fund belongs to.
 *
 * Two values, and one of them is eighteen characters carried on 55 records.
 *
 * The section is not cosmetic: Harvest publishes its two ranges under different
 * URL shapes, so this is what tells the scraper where a fund's page is. That
 * lookup runs against the store, which keeps the long names — the code exists
 * only in the artefact.
 */
export const SECTIONS: Record<string, string> = {
    e: 'etf',
    h: 'high-income-shares',
};

const BY_NAME: Record<string, string> = Object.fromEntries(Object.entries(SECTIONS).map(([code, name]) => [name, code]));

export const sectionName = (code: string | null | undefined): string | null => (code ? (SECTIONS[code] ?? code) : null);
export const codeForSection = (name: string | null | undefined): string | null => (name ? (BY_NAME[name] ?? null) : null);
